import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { DataTable } from "@/components/site/DataTable";
import { COOKIE_POLICY } from "@/data/cookiePolicy";
import { openCookieSettings } from "@/lib/consent";
import { usePageMeta } from "@/lib/pageMeta";
import { useLang } from "@/i18n";

export default function CookiePolicy() {
  const { lang } = useLang();
  const c = COOKIE_POLICY[lang] ?? COOKIE_POLICY.it;
  usePageMeta({ title: c.title, desc: c.intro, path: "/cookie-policy" });
  return (
    <div className="bg-[#F7F5F0] text-[#121110]" data-testid="cookie-policy-page">
      <Nav />
      <main className="px-5 pb-24 pt-44 sm:px-8 lg:pt-52">
        <div className="mx-auto max-w-4xl">
          <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">{c.title}</h1>
          <p className="mt-5 text-sm leading-relaxed text-[#4A453F] sm:text-base">{c.intro}</p>
          <p className="mt-6 text-sm"><b>{c.owner[0]}:</b> {c.owner[1]}</p>
          <div className="mt-10"><DataTable cols={c.cols} rows={c.rows} id="cookie-table" /></div>
          {c.sections.map(([h, p]) => (
            <section key={h} className="mt-10">
              <h2 className="font-display text-xl font-bold tracking-tight">{h}</h2>
              <p className="mt-2 text-sm leading-relaxed text-[#4A453F] sm:text-base">{p}</p>
            </section>
          ))}
          <button onClick={openCookieSettings} className="btn-amber mt-10" data-testid="cookie-policy-settings">{c.settings}</button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
